module.exports = __webpack_public_path__ + "img/icon_button_awaiting.e898625.svg";